/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  var $recoverPasswordForm = $(config.recoverPasswordForm);
  if (!$recoverPasswordForm.length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  // Catch click on "#RecoverPassword"
  $recoverPasswordForm.on('click', toggleForms);

  // Catch click on "#HideRecoverPasswordLink"
  $(config.hideRecoverPasswordLink).on('click', toggleForms);

  /**
   *  Toggle the forms
   */
  function toggleForms(event) {
    event.preventDefault();
    toggleLoginRecoverForm();
  }

  /**
   *  Check if url has hash #recover
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleLoginRecoverForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleLoginRecoverForm() {
    $('#RecoverPasswordForm').toggleClass('no-js');
    $('#CustomerLoginForm').toggleClass('no-js');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {

    // check if reset password form was successfully submitted.
    var $formState = $('.reset-password-success');
    if (!$formState.length) {
      return;
    }

    // show the success message
    $('#ResetSuccess').removeClass('hidden');
  }
})();
